import styled from 'styled-components';
import {device} from '../../../../utils/utils';

export const FaqsCont = styled.div`
  margin: 60px 0 70px 0;
  @media ${device.mobileS} {
    margin: 40px 0;
    padding: 0 20px;
  }
`;
export const FaqsHeading = styled.h3`
  font-size: 32px;
  line-height: 38px;
  font-weight: 900;
  color: #000;
  padding-bottom: 30px;
  border-bottom: 1px solid rgba(101, 101, 101, 0.23);
  @media ${device.mobileS} {
    font-size: 24px;
    line-height: 36px;
    padding-bottom: 16px;
  }
`;
export const FaqsRow = styled.div`
  border-bottom: 1px solid rgba(101, 101, 101, 0.23);
  padding: 24px 0;
`;
export const FaqsQuestion = styled.h4`
  font-size: 24px;
  line-height: 28px;
  font-weight: 700;
  color: #000;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  &::after{
    content: "";
    display: inline-flex;
    border: solid #000;
    border-width: 0 3px 3px 0;
    padding: 3px;
    transform: rotate(45deg);
    transition: all 0.3s linear;
  }
  ${p =>
    p.isActive &&
    `
    &::after{
      transform: rotate(-135deg);
    }
  `}
  @media ${device.mobileS} {
    font-size: 16px;
    line-height: 19px;
  }
`;
export const FaqsList = styled.ul`
  margin-top: 20px !important;
  li {
    font-size: 16px;
    line-height: 26px;
    font-weight: 400;
    color: #000;
    margin-bottom: 20px;
    position: relative;
    padding-left: 15px;
    &:last-child {
      margin-bottom: 0;
    }
    &::before {
      width: 6px;
      height: 6px;
      position: absolute;
      display: inline-flex;
      background-color: #000;
      content: '';
      border-radius: 50%;
      top: 9px;
      left: 0;
    }
  }
  @media ${device.mobileS} {
    li {
      font-size: 14px;
      line-height: 20px;
      color: #333333;
      margin-bottom: 16px;
    }
  }
`;
